export default __webpack_public_path__ + "static/media/Emma 9781408312803.77fe111a.jpg";